import { useState } from "react";
import DialogFormPanel from "../../../../../../../shared/components/panel/DialogFormPanel";
import UpdateButtonTrigger from "../../../../../../../shared/components/button/UpdateButtonTrigger";
import UpdateClientCampaignForm from "./UpdateClientCampaignForm";

const UpdateClientCampaignDialog = ({ campaign, onSubmitHandler }) => {
  const [isOpen, setIsOpen] = useState(false);

  const onSubmit = (formValues) => {
    onSubmitHandler(formValues);
    setIsOpen(false);
  };

  return (
    <DialogFormPanel
      trigger={<UpdateButtonTrigger />}
      title="clients.detail.tabs.campaigns.updateForm.title"
      description="clients.detail.tabs.campaigns.updateForm.description"
      content={
        <UpdateClientCampaignForm
          campaign={campaign}
          onSubmitHandler={onSubmit}
        />
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default UpdateClientCampaignDialog;
